import PayFlow from "./pay-flow"
import { useLocation, useParams } from "react-router-dom"

export default function PayWithExternalScreen() {
  const { shortId } = useParams()
  const {
    state: { payment },
  } = useLocation()

  if (!payment) {
    throw new Error("Payment is required")
  }

  return <PayFlow shortId={shortId!} payment={payment} />
}
